<div class="rf-validation">
  @switch (status()) {
    @case ('loading') {
      <div class="rf-validation__loading">
        <div class="rf-validation__loading-card">
          <aprova-loading-spinner
            color="var(--Icon-Neutral-Primary, #656666)"
            [size]="30"
          />
          <p class="rf-validation__loading-title">
            Consultando Receita Federal...
          </p>
          <p class="rf-validation__loading-description">
            Estamos validando o CPF do representante no quadro societário da empresa.
          </p>
        </div>
      </div>
    }

    @case ('success') {
      <div class="rf-validation__success">
        <div class="rf-validation__success__card">
          <div class="rf-validation__success__icon">
            <aprova-icon name="check-circle-solid" size="32px" color="#059669" />
          </div>
          <p class="rf-validation__success__title">
            Validação Receita Federal concluída!
          </p>
          <p class="rf-validation__success__description">
            O CPF informado de um ou mais representante(s) foi encontrado no quadro societário e validado com sucesso.
          </p>
        </div>
      </div>
    }

    @case ('document-required-intro') {
      <div class="rf-validation__intro">
        <div class="rf-validation__intro-card">
          <div class="rf-validation__intro-icon">
            <aprova-icon
              name="exclamation-circle-solid"
              size="32px"
              color="var(--Icon-Semantic-Warning, #ea580c)"
            />
          </div>
          <h2 class="rf-validation__intro-title">
            Não foi possível validar via Receita Federal
          </h2>
          <p class="rf-validation__intro-description">
            O CPF informado de um ou mais representante(s) não foi encontrado no quadro societário.
            Será necessário enviar documentação comprobatória para prosseguir.
          </p>
          <div class="rf-validation__intro-actions">
            <button
              type="button"
              class="rf-validation__intro-btn rf-validation__intro-btn--secondary"
              (click)="onBackToReview()"
            >
              Voltar e revisar dados
            </button>
            <button
              type="button"
              class="rf-validation__intro-btn rf-validation__intro-btn--primary"
              (click)="goToDocumentUpload()"
            >
              Enviar documentação
            </button>
          </div>
        </div>
      </div>
    }

    @case ('document-required') {
      <div class="rf-validation__document">
        <div class="rf-validation__document__representatives">
          @for (rep of representatives; track rep.cpf) {
            <div class="rf-validation__rep-card">
              @if (getRfResult(rep.cpf)?.valid) {
                <div class="rf-validation__rep-card__success">
                  <span>Representante validado via Receita Federal</span>
                </div>
              } @else {
                <div class="rf-validation__rep-card__error">
                  <aprova-icon
                    name="exclamation-circle-solid"
                    size="20px"
                    color="var(--Icon-Semantic-Warning, #ea580c)"
                  />
                  <div>
                    <p class="rf-validation__rep-card__error-title">Não foi possível validar via Receita Federal</p>
                    <p class="rf-validation__rep-card__error-description">O CPF informado não foi encontrado no quadro societário. Será necessário enviar documentação comprobatória para prosseguir.</p>
                  </div>
                </div>
              }

              <div class="rf-validation__rep-row rf-validation__rep-row--full">
                <span class="rf-validation__rep-label">Nome completo</span>
                <span class="rf-validation__rep-value">{{ rep.nome }}</span>
              </div>
              <div class="rf-validation__rep-row">
                <div class="rf-validation__rep-field">
                  <span class="rf-validation__rep-label">CPF</span>
                  <span class="rf-validation__rep-value">{{ formatCpf(rep.cpf) }}</span>
                </div>
                <div class="rf-validation__rep-field">
                  <span class="rf-validation__rep-label">E-mail</span>
                  <span class="rf-validation__rep-value">{{ rep.email }}</span>
                </div>
              </div>
              <div class="rf-validation__rep-row rf-validation__rep-row--full">
                <span class="rf-validation__rep-label">Papel na empresa</span>
                <span class="rf-validation__rep-value">{{ rep.outraRelacao || getRelacaoLabel(rep.relacao) }}</span>
              </div>

              @if (!getRfResult(rep.cpf)?.valid) {
                <h3 class="rf-validation__document__upload-title">Upload de documento comprobatório</h3>
                <p class="rf-validation__document__upload-hint">
                  Envie um documento que comprove o vínculo do representante com a empresa (contrato social, procuração, etc)
                </p>

                <aprova-file-upload
                  label="Arraste e solte o arquivo ou <span class='file-upload__label-link'>escolha aqui</span>."
                  hint="Formatos aceitos: PDF | Tamanho máximo: 30MB"
                  [acceptedFormats]="['application/pdf']"
                  [maxSizeBytes]="30 * 1024 * 1024"
                  [disabled]="isUploading()"
                  (fileSelected)="onFileSelected(rep.cpf, $event)"
                  (fileRemoved)="onFileRemoved(rep.cpf)"
                />
              }
            </div>
          }
        </div>

        @if (errorMessage()) {
          <p class="rf-validation__error">{{ errorMessage() }}</p>
        }
      </div>
    }
  }
</div>
